import ApiService from '../api.services';

const ScheduleAwayService = {
    list: async function () {
        try {
            const response = await ApiService.get('/api/scheduleaway');
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    get: async function (id) {
        try {
            const response = await ApiService.get(`/api/scheduleaway/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    add: async function (data) {
        try {
            const res = await ApiService.post('/api/scheduleaway', data);
            return res.data;
        } catch (error) {
            throw error;
        }
    },
    update: async function (id, data) {
        try {
            const response = await ApiService.put(`/api/scheduleaway/${id}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async function (id) {
        try {
            const response = await ApiService.delete(`/api/scheduleaway/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default ScheduleAwayService;

export { ScheduleAwayService };

